<template>
   <h1 class="system_content_title">环保信用评价任务</h1>
    <div class="system_content_panels">
      <div class="systemPanel" style="position: relative; padding-bottom: 40px">
    
      <!-- <el-form-item>
        <el-button type="primary" @click="showAdd">新增</el-button>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-input
          v-model="state.searchInput"
          placeholder="请输入名称"
          clearable
          @clear="getTableData"
        >
          <template #append>
            <el-button icon="Search" @click="getTableData" />
          </template>
        </el-input>
      </el-form-item> -->
     
    <el-table
      :data="state.tableData"
      stripe
      v-loading="state.loading"
     style="min-height:70vh"
      table-layout="fixed"
    >
      <el-table-column type="index" width="50" />
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="flowStepname" label="当前流程" />
      <el-table-column prop="nextFlowStepName" label="下一流程" />
      <el-table-column prop="scorelevel1" label="自评等级" />
      <el-table-column prop="score1" label="自评分数" />
      <el-table-column prop="scorelevel2" label="审核等级" />
      <el-table-column prop="score2" label="审核分数" />
      <el-table-column  label="操作" width="120" align="right">
		   <template #default="scope">
            
                
              <el-button
                  size="small"
                  type="warning"
                  @click="showDetail(scope.row.id)"
                  style="margin-bottom: 2px;margin-right:2px"
                  >前往填报</el-button
                >
                <el-button
                  size="small"
                 color="#58B2DC"
                  @click="jumpToAuditHistory(scope.row.id)"
                  style="margin-bottom: 2px;margin-right:2px;color:white"
                  >审核记录</el-button
                >
                  <el-button
                  size="small"
                  color='#337d7f'
                  v-if="scope.row.flowStepId==205"
                  @click="jumpToAppeal(scope.row.id)"
                  style="margin-bottom: 2px;margin-right:2px"
                  >申诉</el-button
                >
		
		   </template>
	  </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="state.pageInfo.pageIndex"
      :page-sizes="[20, 50, 100, 200, 500, 1000]"
      :page-size="state.pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="state.pageInfo.totalRowCount"
      v-if="state.pageInfo.totalRowCount"
      class="pageinfo"
    >
    </el-pagination>
     </div>
    <el-dialog
      v-model="state.addVisible"
      title="添加企业"
      width="30%"
      :before-close="handleClose"
    >

  请选择用户：
      <el-select
        v-model="state.addCompanyList"
        filterable
        remote
        multiple
        placeholder="输入名称或信用代码"
        :remote-method="searchUser"
        :loading="state.addSearchLoading"
        style="margin-bottom: 10px"
      >
        <el-option
          v-for="item in state.userList"
          :key="item.id"
          :label="item.name + ' - ' + item.orgCode"
          :value="item.id"
        />
      </el-select>
 
    
  
      <template #footer>
        <span class="dialog-footer" style="margin: 0 auto">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            @click="setUserRole"
            :disabled="!state.addUser || !state.role"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage } from "element-plus";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { DArrowLeft } from "@element-plus/icons-vue";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    // const roleId = router.currentRoute.value.query.roleId
    const state = reactive({
      tableData: [],
      loading: false,
      searchInput: "",
      pageInfo: {},
      addVisible: false,
      addSearch: "",
      addSearchLoading: false,
      roleList: [],
      userList: [],
      addUser: null,
      role: null,
      companySearchInput:"",
    });

    const getTableData = async () => {
      state.loading = true;
      const { data } = await api.reviewTaskApi.getCompanyTaskList({
        page: state.pageInfo.pageIndex || 1,
        rows: state.pageInfo.pageSize || 20,
        sort: "",
        value: state.searchInput,
        // intId: parseInt(roleId)
      });
      if (data.isSuccessful) {
        state.loading = false;
        state.tableData = data.resultObj.data;
        state.pageInfo = data.resultObj.pagerInfo;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };
    getTableData();
  
    const getRoleList = async (e) => {
      state.addSearchLoading = true;
      const { data } = await api.userApi.queryRole({
        page: 1,
        rows: 299,
        order: "asc",
        sort: "",
        value: "",
      });
      console.info("search user", data);
      if (data.isSuccessful) {
        state.roleList = data.resultObj.data;
      }
      state.addSearchLoading = false;
    };
    getRoleList();
   
	 const deleteItem = async (id) => {
      state.addSearchLoading = true;
      const { data } = await api.userApi.deleteUserRole(id);
      console.info("search user", data);
      if (data.isSuccessful) {
		 ElMessage({
          message: data.resultMsg,
          type: "success",
        });
       getTableData()
      }else{
		 ElMessage({
          message: data.resultMsg||"未知错误",
          type: "error",
		  grouping:true
        });
	  }
      state.addSearchLoading = false;
    };
    const handleClose = () => {
      state.addVisible = false;
      state.addSearch = "";
      state.addUser = "";
    };
    const setUserRole = async () => {
      const userId = state.addUser;
      let currentUser = null;
      state.userList.forEach((item) => {
        if (item.id == userId) {
          currentUser = item;
        }
      });
      console.info("currentUser", currentUser);
      console.info("currentrole", state.role);

      const { data } = await api.userApi.setUserRole({
        userId,
        loginName: currentUser.loginName,
        roleId: state.role.id,
      });
      console.info("search user", data);
      if (data.isSuccessful) {
        ElMessage({
          message: "操作成功",
          type: "success",
        });
		handleClose()
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
    };
  
  
    const showDetail =async (id)=>{
      
// const {data}=await api.reviewTaskApi.getReviewFormByID(id)
// console.info("get review form",data)
   
    const path = `/system/review/reviewSubmit?unitAID=${id}`;
      const routerData = router.resolve(path);
      window.open(routerData.href, "_blank");
      return
    }
       
    const jumpToAppeal =async (id)=>{
      
// const {data}=await api.reviewTaskApi.getReviewFormByID(id)
// console.info("get review form",data)
   
    const path = `/system/review/reviewAppealAlt?taskID=${id}`;
      const routerData = router.resolve(path);
      window.open(routerData.href, "_blank");
      return
    }
    const jumpToAuditHistory =async (id)=>{
      
// const {data}=await api.reviewTaskApi.getReviewFormByID(id)
// console.info("get review form",data)
   
    const path = `/system/review/auditHistoryCompany?taskID=${id}`;
      const routerData = router.resolve(path);
      window.open(routerData.href, "_blank");
      return
    }
       
      const searchUser = async (e) => {
      state.addSearchLoading = true;
      const { data } = await api.companyApi.getGZCompanies({
         page: 1,
        rows: 299,
        order: "asc",
        sort: "",
        value: e,
      });
      console.info("search user", data);
      if (data.isSuccessful) {
        state.userList = data.resultObj.data;
      }
      state.addSearchLoading = false;
    };
    return {
      state,
      getTableData,
      searchUser,
      handleClose,
      setUserRole,
	  deleteItem,
    showDetail,
    jumpToAppeal,
    jumpToAuditHistory
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.state.pageInfo.pageIndex = val;
      this.getTableData();
    },
    getBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
